<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.667 9.941h-3.334V5h-5v4.941H6l5.833 5.765 5.834-5.765ZM6 17.353V19h11.667v-1.647H6Z" fill="currentColor" /></svg>
</template>
